import moment from "moment";
import numeral from 'numeral';

export const formatTime = (value) => {
  if (!value) return null;
  if (/^\d\d:\d\d:\d\d$/.test(value)) return value;
  const m = moment(value);
  if (m.isValid()) return m.format('HH:mm:ss');
  return null;
};
export const formatDate = (value) => value ? moment(value).format('DD.MM.YYYY') : null;
export const formatDateTime = (value) => value ? moment(value).format('DD.MM.YYYY HH:mm:ss'): null;
export const formatPrice = (value) => value ? numeral(value).format('0,0.00') : "0.00";
export const formatInteger = (value) => value ? numeral(value).format('0,0') : "0";
